const zh = {
	transactionDate: '交易日期',
	totalTXNs: '交易总笔数',
	successTXNs: '成功笔数',
	riskDeclinedTXNs: '风控拒绝笔数',
	bankDeclinedTXNs: '银行拒绝笔数',
	otherDeclinedTXNs: '其他失败笔数',
	txnSuccessRate: '交易成功率',
	bankDeclinedTXNsExcluded: '交易成功率（去除持卡人原因)',

	group: '群组',
	store: '网站',
	omniStore: '网站/门店',
	currency: '交易币种',
	tradeAnalysis: '交易分析',
	saleData: '销售数据',
	export: '导出',
	succAmount: '成功金额',
	succAmountDesc: '金额仅供参考，若需分币种查看，请指定“交易币种”',
	refundAnalysis: '退款分析',
	refundRate: '退款率',
	refundAmount: '退款金额',
	numberRefund: '退款笔数',
	refundAmtRatio: '退款金额占比',
	refundRateTip: '退款率=退款笔数（去重）/成功笔数。退款金额占比=退款金额/成功金额',
	succRate: '成功率',
	succRateAnalysis: '成功率分析',
	succRateTip: '成功率=成功笔数/PingPongPay受理的交易总笔数',
	TXN: '注：TXN是指交易',
	regionDistri: '国家/区域分布（成功笔数）',
	cbIn6: '近6个月拒付数据',
	cbRate: '拒付率',
	total: '总计',
	cbNumber: '拒付笔数',
	cbReason: '拒付原因',
	fraud: '欺诈类',
	notAsDescribed: '货不对板',
	notReceived: '未收到货',
	other: '其他',
	chargebackAnalysis: '拒付分析',
	cbWarning: '拒付预警',
	cbWarningAmount: '预警金额',
	cbWarningCnt: '预警笔数',
	covertedUSD: '因拒付币种不同，拒付预警金额按照折算成美金金额计算，仅供参考',
	month: '月份',
	amount: '金额',
	number: '成功笔数',
	count: '笔数',
	day7: '近7天',
	day30: '近一个月',
	day90: '近3个月',
	day180: '近6个月',
	currentMonth: '本月',
	current: '当期',
	compare: '同期',
	compareText: '对比',
	lastPeriod: '上一期',
	lastMonth: '上个月',
	lastQuarter: '上一季度',
	lastYear: '去年',
	noCompare: '无对比',
	custom: '自定义',
	quantities: '数量',
	tipText: '提示：统计时间以UTC +0为准',
	refundTipText: '金额仅供参考，若需分币种查看，请指定币种',
	cbRateTipText: '拒付率=拒付笔数/成功笔数',
	queryType: '查询',
	paymentMethod: '支付方式',
	country: '国家及地区',
	failAnalysis: '失败原因分析',
	failReasonRatio: '失败原因占比',
	failureTip: '失败原因以请求维度分析数据，非订单维度。',
	type: '类型',
	comparisonTable: '失败类型与PP状态码对照表',
	klarnaAnalysis: 'Klarna争议分析',
	disputeRate: '争议率',
	disputeRateTips: '争议率=当月Klarna争议笔数/当月成功交易笔数',
	disputeEscalationRate: '争议升级率',
	disputeEscalationRateTips: '争议升级率=当月Klarna调单笔数（升级的争议）/当月成交易笔数',

	disputeReason: '争议原因',
	retrievalReason: '调单原因',
	returns: '退货',
	goodsNotReceived: '未收到货',
	incorrectInvoice: '账单错误',
	faultyGoods: '瑕疵商品',
	alreadyPaid: '重复付款',
	unauthorizedPurchases: '未授权',
	successfulTransactions: '成功交易笔数',
	time: '时间',

	dispute: '争议笔数',
	retrieval: '争议升级笔数(调单)',
	chargeback: '拒付笔数(败诉)',
	disputeListTitle: '近三个自然月的争议数据概览',
	disputeListWarn: '贵司当前连续两个月争议升级率超标（≥1.5%），请及时采取措施降低争议升级率'
}

export default zh
